import { type Customer, type Opportunity, useOpportunity } from "@repo/api";
import { type ApiError } from "@repo/api/src/ApiError";
import { PROJECT_REFRESH_INTERVAL_MS } from "@repo/utils";
import { type ReactNode, createContext, useContext } from "react";
import { useParams } from "react-router-dom";

interface ActiveProject {
  opportunity?: Opportunity;
  isValidating: boolean;
  isLoading: boolean;
  error?: ApiError;
  customer?: Customer;
}

const ActiveProjectContext = createContext<ActiveProject>({} as ActiveProject);

interface Props {
  children: ReactNode;
  opportunityId?: number;
}
export const ActiveProjectProvider = ({ children, opportunityId }: Props) => {
  const { opportunityId: urlId } = useParams();
  const id = opportunityId
    ? Number(opportunityId)
    : urlId
      ? Number(urlId)
      : undefined;

  const {
    data: opportunity,
    isValidating,
    isLoading,
    error,
  } = useOpportunity(id, PROJECT_REFRESH_INTERVAL_MS);

  return (
    <ActiveProjectContext.Provider
      value={{
        opportunity,
        isValidating,
        isLoading,
        error,
      }}
    >
      {children}
    </ActiveProjectContext.Provider>
  );
};

export const useActiveProject = () => useContext(ActiveProjectContext);
